import {Injectable, NgZone} from '@angular/core';
import {Router} from '@angular/router';
import {from, Observable} from 'rxjs';
import {UsersService} from './users.service';
import {AuthUser, fetchAuthSession, getCurrentUser, signOut, updatePassword,} from 'aws-amplify/auth';
import {AuthSession} from "@aws-amplify/core/dist/esm/singleton/Auth/types";
import {MatDialog} from "@angular/material/dialog";
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from "./auth.service";
import {map} from "rxjs/operators";
import {Hub} from 'aws-amplify/utils';
import {User} from "../model/user";


@Injectable({
  providedIn: 'root'
})
export class CognitoAuthService extends AuthService {
  private _cognitoUser?: AuthUser;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private dialogService: MatDialog,
    private usersService: UsersService,
    private httpClient: HttpClient,
    private snackBar: MatSnackBar,
  ) {
    super();

    Hub.listen('auth', (data) => {
      console.log(data);
      switch (data.payload.event) {
        case 'signedIn':
          this.fillInternalUser(data.payload.data as AuthUser);
          break;

        case 'signedOut':
          this.flushState();
          console.info('user signed out');
          break;

        case 'tokenRefresh':
          console.info('token refresh succeeded');
          break;

        case 'tokenRefresh_failure':
          console.error('token refresh failed');
          break;

      }
    });

    getCurrentUser().then(user => this.fillInternalUser(user)).catch(() => this.flushState());
  }

  override getToken(): Observable<string> {
    return from(fetchAuthSession()).pipe(map((session: AuthSession) => session.tokens?.idToken?.toString()));
  }

  override login(): void {
    this.ngZone.run(() => this.router.navigate(['/login']));
  }

  override logout(): void {
    signOut().then(() => this.flushState());
  }

  override clearUser(): void {
    this.dialogService.closeAll();
    signOut();
  }

  override changePassword(oldPassword: string, newPassword: string): Observable<void> {
    return from(updatePassword({oldPassword, newPassword}));
  }

  override refreshUser(): void {
    if (!this._cognitoUser) {
      throw new Error("The Cognito user is undefined");
    }
    this.fillInternalUser(this._cognitoUser);
  }

  private async fillInternalUser(user: AuthUser): Promise<void> {
    this._cognitoUser = user;

    try {
      const cognitoId = user.username;
      const user$: Observable<User> = this.usersService.getUser(cognitoId);
      user$.subscribe(user => {
        this._internalUser = user;
        this.behaviorUser.next(this._internalUser);
      });
    } catch (error) {
      console.error(error);
    }
  }

  private flushState(): void {
    this._cognitoUser = undefined;
    this._internalUser = undefined;
    this.behaviorUser.next(undefined);
    this.ngZone.run(() => this.router.navigate(['/']));
  }
}
